import React from "react";
import HorseRace from "./HorseRace";

function App() {
  return (
    <div>
      <HorseRace />
    </div>
  );
}

export default App;